import { Component, Element, h, Prop, State, Host, Listen } from '@stencil/core';
import { RouterHistory, injectHistory } from '@stencil/router';
import { HTMLStencilElement } from '@stencil/core/internal';
import { getGlobalAssetsPath } from '../../utils/getGlobalAssetsPath';
import { store } from '../../utils/store';

@Component({
  tag: 'app-header',
  shadow: false,
})
export class AppHeader {

  @Element() el: HTMLStencilElement;
  @Prop({mutable: true}) history: RouterHistory;
  @State() isOpen = false;
  private languageSelector: HTMLDivElement;

  @Listen('click', { target: 'document' })
  public watchClickOutside({ target }: PointerEvent): void {
    if (!this.isOpen) {
      return;
    }
    const clickInLanguageSelector = target === this.languageSelector;
    if (!clickInLanguageSelector) {
      this.isOpen = false;
    }
  }

  render() {
    return (
        <Host>
            <div class="container">
                <div class="header__wrapper">
                    <div class="header__logo-wrapper ">
                        <div class="header__logo">
                          <a class="link-active" href={window.location.toString()}>
                                <img class="logo-text" src={getGlobalAssetsPath('images/retro-logo-text.svg')} />
                                <img class="logo-icon" src={getGlobalAssetsPath('images/retro-logo-icon.svg')} />
                          </a>
                        </div>
                        <div class="header__retro-logo">
                            <img src={getGlobalAssetsPath('images/logo.png')} />
                        </div>
                    </div>
                    <div class="header__selector">
                        <div ref={(el) => { this.languageSelector = el; }}
                             onClick={(e) => { e.stopPropagation(); }}
                             class={{'language-selector': true, 'language-selector--open': this.isOpen }}
                        >
                          <app-locale-selector
                            class="language-selector__locale"
                            onBelimoLocaleSelected={(e) => { e.stopPropagation(); this.isOpen = false; }}
                          >
                            <div slot="close"
                                 onClick={(e) => { e.stopPropagation();  this.isOpen = false; }}
                                 class="language-selector__close" >
                              <belimo-svg-sprite svgId={'x'} />
                            </div>
                          </app-locale-selector>
                          <app-country-selector class="language-selector__country" />
                        </div>

                        <div class="header__selectorCurrent">
                            <app-locale-selector class="header__selectorLocale" full={false}/>
                            <div class="header__selectorRegion"
                                 onClick={(e) => { e.stopPropagation(); this.isOpen = true; } }
                            >
                                <belimo-svg-sprite svgId={'globe'} />
                                <render-country countryCode={store.get('currentCountry')} />
                                <belimo-svg-sprite svgId={'chevron-down'} />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </Host>
    );
  }
}

injectHistory(AppHeader);
